import { render } from "./Wechat.vue?vue&type=template&id=4fa3b6f0"
import script from "./Wechat.vue?vue&type=script&lang=js"
export * from "./Wechat.vue?vue&type=script&lang=js"

import "./Wechat.vue?vue&type=style&index=0&id=4fa3b6f0&lang=scss&Scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__